import { useRef } from "react";
const noop = () => {
};
function on(obj, ...args) {
  if (obj && obj.addEventListener) {
    obj.addEventListener(...args);
  }
}
function off(obj, ...args) {
  if (obj && obj.removeEventListener) {
    obj.removeEventListener(...args);
  }
}
const isBrowser = typeof window !== "undefined";
const isNavigator = typeof navigator !== "undefined";
function getClosestBody(el) {
  if (!el) {
    return null;
  }
  if (el.tagName === "BODY") {
    return el;
  }
  if (el.tagName === "IFRAME") {
    const document2 = el.contentDocument;
    return document2 ? document2.body : null;
  }
  if (!el.offsetParent) {
    return null;
  }
  return getClosestBody(el.offsetParent);
}
function preventDefault(rawEvent) {
  const e = rawEvent || window.event;
  if (e.touches.length > 1) {
    return true;
  }
  if (e.preventDefault) {
    e.preventDefault();
  }
  return false;
}
const isIosDevice = isBrowser && window.navigator && window.navigator.platform && /iP(ad|hone|od)/.test(window.navigator.platform);
const bodies = /* @__PURE__ */ new Map();
const doc = typeof window.document === "object" ? window.document : void 0;
let documentListenerAdded = false;
function useLockBody(locked = true, elementRef) {
  const bodyRef = useRef(doc.body);
  elementRef = elementRef || bodyRef;
  const body = getClosestBody(elementRef.current);
  const lock = () => {
    if (body) {
      const bodyInfo = bodies.get(body);
      if (!bodyInfo) {
        bodies.set(body, { counter: 1, initialOverflow: body.style.overflow });
        if (isIosDevice) {
          if (!documentListenerAdded) {
            on(document, "touchmove", preventDefault, { passive: false });
            documentListenerAdded = true;
          }
        } else {
          body.style.overflow = "hidden";
        }
      } else {
        bodies.set(body, {
          counter: bodyInfo.counter + 1,
          initialOverflow: bodyInfo.initialOverflow
        });
      }
    }
  };
  const unlock = () => {
    if (body) {
      const bodyInfo = bodies.get(body);
      if (bodyInfo) {
        if (bodyInfo.counter === 1) {
          bodies.delete(body);
          if (isIosDevice) {
            body.ontouchmove = null;
            if (documentListenerAdded) {
              off(document, "touchmove", preventDefault);
              documentListenerAdded = false;
            }
          } else {
            body.style.overflow = bodyInfo.initialOverflow;
          }
        } else {
          bodies.set(body, {
            counter: bodyInfo.counter - 1,
            initialOverflow: bodyInfo.initialOverflow
          });
        }
      }
    }
  };
  return { lock, unlock };
}
export {
  getClosestBody,
  isBrowser,
  isNavigator,
  noop,
  off,
  on,
  useLockBody
};
